/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  TYPE_APARTMENT,
  TYPE_COMMERCIAL_PREMISE,
  TYPE_HOUSE,
  TYPE_TERRAIN
} from '../../enums/EstateTypeCodes.mjs'

export type EstateTypeLabelProps = {
  value: EstateType
}

function EstateTypeLabel (props: EstateTypeLabelProps) {
  const { value } = props
  const intl = useIntl()

  if (value === TYPE_APARTMENT) {
    return intl.formatMessage({
      id: 'apartment',
      defaultMessage: 'Appartement'
    })
  }
  if (value === TYPE_HOUSE) {
    return intl.formatMessage({
      id: 'house',
      defaultMessage: 'Maison'
    })
  }
  if (value === TYPE_COMMERCIAL_PREMISE) {
    return intl.formatMessage({
      id: 'commercial_premise',
      defaultMessage: 'Local'
    })
  }
  if (value === TYPE_TERRAIN) {
    return intl.formatMessage({
      id: 'terrain',
      defaultMessage: 'Terrain'
    })
  }
  return null
}

export default EstateTypeLabel
